export default __webpack_public_path__ + "static/media/avatar.21d108f8.jpg";